import configureMockStore from 'redux-mock-store';
import { applyMiddleware, createStore, DeepPartial, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import notifications from '../state/src/notifications-slice';

const rootReducer = combineReducers({ notification: notifications });

const createReduxStore = (initialState?: DeepPartial<any>) => {
  // This only a test utility, TypeCheck no longer likes DeepPartial as it is not able to check the nested types well
  return createStore(rootReducer, initialState, applyMiddleware(thunk));
};

export const createReduxStoreWithActions = (initialState?: DeepPartial<any>) => {
  const thunkMiddleware = [thunk];
  const mockStore = configureMockStore<any>(thunkMiddleware);
  return mockStore(initialState as any);
};

export default createReduxStore;
